<template>
  <div>
    <RuleIfElseCondition
      v-if="selectIf"
      v-model="selectIf"
      :rule-property-enum="RULE_PROPERTY.if"
      :parent-rule-reference="ruleReference"
      :title="trans(`subscription.validation_rules.rules.if.if`)"
      :rule="rule.if"
    />
    <RuleIfElseCondition
      v-if="selectThen"
      v-model="selectThen"
      :rule-property-enum="RULE_PROPERTY.then"
      :parent-rule-reference="ruleReference"
      :title="trans(`subscription.validation_rules.rules.if.then`)"
      :rule="rule.then"
      display-divider
    />
    <div v-if="selectElse">
      <RuleIfElseCondition
        v-model="selectElse"
        :rule-property-enum="RULE_PROPERTY.else"
        :parent-rule-reference="ruleReference"
        :title="trans(`subscription.validation_rules.rules.if.else`)"
        :rule="rule.else"
        display-delete
        display-divider
      />
    </div>
    <RuleSmallButton
      v-else
      :title="'Voeg anders toe '"
      type="button"
      class="focus-style btn-warning ms-4 m-3"
      @click.native="addRuleProperty(RULE_PROPERTY.else)"
    />
  </div>
</template>

<script>
import { RULE_PROPERTY } from '@/constants'
import { buildSubscriptionsCountRule } from '@/employees/components/Rule/utilities/builder/ruleBuilder'
import ruleMixin from '@/employees/components/Rule/utilities/mixins/ruleMixin'
export default {
  name: 'RuleIfElse',
  mixins: [ruleMixin],
  props: {
    ruleReference: {
      required: true,
      type: String,
    },
    rule: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      selectIf: null,
      selectThen: null,
      selectElse: null,
      RULE_PROPERTY: RULE_PROPERTY,
    }
  },
  mounted () {
    if (this.rule.if) {
      this.selectIf = this.rule.if.type
    }
    if (this.rule.then) {
      this.selectThen = this.rule.then.type
    }
    if (this.rule.else) {
      this.selectElse = this.rule.else.type
    }
  },
  methods: {
    addRuleProperty (rulePropertyEnum) {
      this.rulePropertyValueAdd(this.ruleReference, rulePropertyEnum, buildSubscriptionsCountRule())
    },
  },
}
</script>

<style lang="scss" scoped>
.focus-style{
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5) !important;
  }
}
</style>
